import React from 'react';
import { STYLES } from '@eb/eds-button';

import { CameraGraphic } from '@eb/eds-iconography';

export const PRIMARY_TYPES = STYLES;
export const DEFAULT_GRAPHIC = <CameraGraphic />;
export const DEFAULT_TYPE = 'fill';
